import { defineMessages } from "react-intl";

export const messages = defineMessages({
  netPrice: {
    id: "modification.translation.netPrice",
    defaultMessage: "NET PRICE",
  },
  usePoint: {
    id: "modification.translation.usePoint",
    defaultMessage: "Use point",
  },
  noRate: {
    id: "modification.translation.noRate",
    defaultMessage: "- means no rate",
  },
  deposit: {
    id: "modification.translation.deposit",
    defaultMessage: "Deposit",
  },
  extras: {
    id: "modification.translation.extras",
    defaultMessage: "Extras",
  },
  netPriceHelpText0: {
    id: "modification.translation.netPriceHelpText0",
    defaultMessage: "Input net price per accommodation/night",
  },
  netPriceHelpText1: {
    id: "modification.translation.netPriceHelpText1",
    defaultMessage: "Input net price per accommodation/night",
  },
  netPriceHelpText2: {
    id: "modification.translation.netPriceHelpText2",
    defaultMessage: "Input net price per accommodation/night",
  },
  netPriceTotal: {
    id: "modification.translation.netPriceTotal",
    defaultMessage: "Total Price",
  },
  netPriceTotalHelpText: {
    id: "modification.translation.netPriceTotalHelpText",
    defaultMessage: "The amount is multiplied by the number of rooms booked",
  },
  extrasTotal: {
    id: "modification.translation.extrasTotal",
    defaultMessage: "Extras amount",
  },
  grandTotal: {
    id: "modification.translation.grandTotal",
    defaultMessage: "Booking amount",
  },
  quantity: {
    id: "modification.translation.quantity",
    defaultMessage: "Quantity",
  },
  checkIn: {
    id: "modification.translation.checkIn",
    defaultMessage: "checkIn",
  },
  checkOut: {
    id: "modification.translation.checkOut",
    defaultMessage: "checkOut",
  },
  comments: {
    id: "modification.translation.comments",
    defaultMessage: "Comments",
  },
  internalNotes: {
    id: "modification.translation.internalNotes",
    defaultMessage: "Internal Notes",
  },
  pricePerDay: {
    id: "modification.translation.pricePerDay",
    defaultMessage: "pricePerDay",
  },
  discount: {
    id: "modification.translation.discount",
    defaultMessage: "discount",
  },
  totalPrice: {
    id: "modification.translation.totalPrice",
    defaultMessage: "totalPrice",
  },
  dateHeader: {
    id: "modification.translation.dateHeader",
    defaultMessage: "date",
  },
  ariPriceHeader: {
    id: "modification.translation.ariPriceHeader",
    defaultMessage: "ariPrice",
  },
  appliedPriceHeader: {
    id: "modification.translation.appliedPriceHeader",
    defaultMessage: "appliedPrice",
  },
  discountHeader: {
    id: "modification.translation.discountHeader",
    defaultMessage: "discount",
  },
  finalPriceHeader: {
    id: "modification.translation.finalPriceHeader",
    defaultMessage: "finalPrice",
  },
  restrictionsHeader: {
    id: "modification.translation.restrictionsHeader",
    defaultMessage: "restrictions",
  },
  promosHeader: {
    id: "modification.translation.promosHeader",
    defaultMessage: "promos",
  },
  insertPrice: {
    id: "modification.translation.insertPrice",
    defaultMessage: "insertPrice",
  },
  room: {
    id: "modification.translation.inventoryTicker",
    defaultMessage: "insertPrice",
  },
  day: {
    id: "modification.translation.day",
    defaultMessage: "day",
  },
  discountTooltip: {
    id: "modification.translation.discountTooltip",
    defaultMessage: "discountTooltip",
  },
  availability: {
    id: "modification.translation.messages.availability",
    defaultMessage: "availability",
  },
  stop: {
    id: "modification.translation.messages.stop",
    defaultMessage: "stop",
  },
  minStay: {
    id: "modification.translation.messages.minStay",
    defaultMessage: "minStay",
  },
  maxStay: {
    id: "modification.translation.messages.maxStay",
    defaultMessage: "maxStay",
  },
  minAdv: {
    id: "modification.translation.messages.minAdv",
    defaultMessage: "minAdv",
  },
  maxAdv: {
    id: "modification.translation.messages.maxAdv",
    defaultMessage: "maxAdv",
  },
  name: {
    id: "modification.translation.messages.name",
    defaultMessage: "name",
  },
  type: {
    id: "modification.translation.messages.type",
    defaultMessage: "type",
  },
  travelWindow: {
    id: "modification.translation.messages.travelWindow",
    defaultMessage: "tavelWindow",
  },
  bookingWindow: {
    id: "modification.translation.messages.bookingWindow",
    defaultMessage: "bookingWinndow",
  },
  multiple: {
    id: "modification.translation.messages.multiple",
    defaultMessage: "multiple",
  },
});
